<template>
  <div :class="['modal-container', showModal && 'modal-container--show']">
    <div class="modal-container__container">
      <div class="modal-container__mask">
        <div class="modal-container__close-btn-wrapper">
          <button
            @click="handleCloseModal"
            class="btn btn--tertiary btn--small modal-container__close-btn"
          >
            <CloseModalXIcon />
          </button>
        </div>
        <slot :close-modal="handleCloseModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import CloseModalXIcon from '@/assets/icons/close_modal_x.svg'

export default {
  name: 'ModalContainer',
  components: {
    CloseModalXIcon: { ...CloseModalXIcon, name: 'CloseModalXIcon' },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    ...mapMutations({
      setIsSignInModalShown: 'app/IS_SIGN_IN_MODAL_SHOWN_UPDATED',
    }),
    handleCloseModal() {
      this.setIsSignInModalShown(false)
    },
  },
  computed: {
    ...mapState({
      isSignInModalShown: state => state.app.isSignInModalShown,
    }),
    showModal: {
      // getter
      get() {
        return this.show
      },
      // setter
      set(newValue) {
        this.show = newValue
      },
    },
  },
  mounted() {
    setTimeout(() => (this.show = true), 100)
  },
}
</script>

<style lang="scss">
.modal-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  @media screen and (max-width: 768px) {
    z-index: 9999;
  }
  opacity: 0;
  transition: opacity 0.3s ease-out;
  &--show {
    opacity: 1;
  }
  &__container {
    background: #222222;
    height: fit-content;
    width: 100vw;
    @include tablet {
      border-radius: 35px;
      width: 500px;
    }
  }
  &__mask {
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    padding: 40px;
    height: 100%;
    width: 100%;
    display: grid;
    @include tablet {
      border-radius: 35px;
    }
  }
  &__close-btn {
    &-wrapper {
      text-align: right;
      height: 0;
    }
    position: relative;
    bottom: 20px;
    left: 20px;
    width: 36px;
    svg {
      width: 24px !important;
      height: 24px !important;
    }
  }
}
</style>
